import React from 'react';

interface MetricCardProps {
  title: string;
  cuantity?: string | number;
  value: string | number;
  icon: React.ReactNode;
  color?: string;
  onClick?: () => void;
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  title, 
  cuantity, 
  value, 
  icon, 
  color,
  onClick 
}) => {
  const cantidaFormateada = Math.round(Number(cuantity));
  return (
    <div 
      className={`bg-white py-2 px-3 rounded-lg border border-gray-200 w-auto
        hover:border-gray-300 transition-colors duration-200 ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={onClick}>
      <div className="flex items-center gap-3">
        {/* Columna 1: Icono */}
        <div className="flex-shrink-0 flex items-center justify-center">
          <span className={`text-${color}-600 text-lg bg-${color}-100 rounded-full p-0.5`}>
            {icon}
          </span>
        </div>
        
        {/* Columna 2: Título y Valor */}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-500 font-medium mb-0.5 truncate">{title}</p>
          <p className="text-md font-bold text-gray-900 leading-tight">
            {typeof value === 'number' ? value.toLocaleString('es-CO') : value}
          </p>
          {cuantity && (
            <span className="text-sm text-gray-400 font-normal">
              {cantidaFormateada.toLocaleString('es-CO')}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
